import { useMutation } from "@tanstack/react-query";
import { workClient } from "../clients/workClient";
import { useWorkScope } from "../components/WorkScopeProvider";
import type { AssessWorkRequestInput } from "../types/workRequest";
import { assessWorkRequestResponseSchema } from "../types/workRequestApi";

// No success/error toasts: this is a silent, best-effort pre-submit check.
// Callers fail open on error, proceeding directly to creation rather than
// blocking submission.
export function useAssessWorkRequestMutation() {
  const { selectedCustomer, selectedFacility } = useWorkScope();

  return useMutation({
    mutationFn: async (input: AssessWorkRequestInput) => {
      if (!selectedCustomer || !selectedFacility) {
        throw new Error("A customer and facility must be selected.");
      }

      const response = await workClient.v1.customers[":customerId"].facilities[
        ":facilityId"
      ].requests.assess.$post({
        param: {
          customerId: selectedCustomer.id,
          facilityId: selectedFacility.id,
        },
        json: input,
      });

      if (!response.ok) {
        throw new Error(
          `Failed to assess the Work Request: ${response.status}`,
        );
      }

      return assessWorkRequestResponseSchema.parse(await response.json());
    },
  });
}
